import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router'
import { ROUTES } from '@constants/index'
import { useEnvironment } from '@hooks/useEnvironment'
import { FallbackIndicator } from '@components/ui/Loader/FallbackIndicator'
import Error from '@pages/Error'
import { LoginRedirect } from './LoginRedirect'
import { StartRedirect } from './StartRedirect'
import { ResumeRedirect } from './ResumeRedirect'

const Introduction = React.lazy(() => import('@pages/Introduction'))
const EligibleInsurers = React.lazy(() => import('@pages/EligibleInsurers'))
const InsuranceInformationForm = React.lazy(() => import('@pages/InsuranceInformationForm'))
const Quote = React.lazy(() => import('@pages/Quote'))
const SelectPrescription = React.lazy(() => import('@pages/SelectPrescription'))
const ValidatePrescription = React.lazy(() => import('@pages/ValidatePrescription'))
const SelectProducts = React.lazy(() => import('@pages/SelectProducts'))
const ReviewClaim = React.lazy(() => import('@pages/ReviewClaim'))
const InsuranceMember = React.lazy(() => import('@pages/InsuranceMember'))
const Loading = React.lazy(() => import('@pages/Loading'))
const ChangeInsuredProduct = React.lazy(() => import('@pages/InsuranceMember/components/ChangeInsuredProduct'))

export const AppRoutes: React.FC = () => {
  const { basePath } = useEnvironment()
  const dbpath = basePath.endsWith('/') ? ROUTES.BASE_NO_SLASH : ROUTES.BASE

  return (
    <Suspense fallback={<FallbackIndicator />}>
      <Routes>
        <Route path={`${basePath}${dbpath}`}>
          <Route index element={<Introduction />} />
          <Route path={ROUTES.LOGIN_REDIRECT} element={<LoginRedirect />} />
          <Route path={ROUTES.START} element={<StartRedirect />} />
          <Route path={ROUTES.RESUME} element={<ResumeRedirect />} />
          <Route path={ROUTES.INSURANCE_INFORMATION} element={<InsuranceInformationForm />} />
          <Route path={ROUTES.QUOTE} element={<Quote />} />
          <Route path={ROUTES.ELIGIBLE_INSURERS} element={<EligibleInsurers />} />
          <Route path={ROUTES.SELECT_PRESCRIPTION} element={<SelectPrescription />} />
          <Route path={ROUTES.VALIDATE_PRESCRIPTION} element={<ValidatePrescription />} />
          <Route path={ROUTES.SELECT_PRODUCT} element={<SelectProducts />} />
          <Route path={ROUTES.CHANGE_INSURED_PRODUCT} element={<ChangeInsuredProduct />} />
          <Route path={ROUTES.REVIEW_CLAIM} element={<ReviewClaim />} />
          <Route path={ROUTES.INSURANCE_MEMBER} element={<InsuranceMember />} />
          <Route path={ROUTES.ERROR} element={<Error />} />
          <Route path={ROUTES.LOADING} element={<Loading />} />
        </Route>
      </Routes>
    </Suspense>
  )
}
